import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { Perforgo } from "@perforgo/lib";
export default defineNuxtPlugin((_nuxtApp) => {
  const config = useRuntimeConfig();
  const perforgo = new Perforgo({
    appId: config.public.perforgo.appId,
    domainName: config.public.perforgo.domainName,
    enabledFeatures: {
      lcp: config.public.perforgo.enabledFeatures.lcp,
      fcp: config.public.perforgo.enabledFeatures.fcp,
      inp: config.public.perforgo.enabledFeatures.inp,
      ttfb: config.public.perforgo.enabledFeatures.ttfb,
      resourceMonitoring: {
        images: config.public.perforgo.enabledFeatures.resourceMonitoring.images
      }
    }
  });
  perforgo.init();
});
